export { Default as Accordion } from './default/default'
export type { ThemeClasses as AccordionThemeClasses } from './default/default'
